import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { GeoJSONObject } from '@/types/geospatial'

export interface GetPhysiologicalDiagnosesMapResponse {
  layers: GeoJSONObject
  fields: GeoJSONObject
}

export const getPhysiologicalDiagnosesMap = async (
  id: string,
  config?: AxiosRequestConfig,
) => {
  const { data } = await companiesApi.get<GetPhysiologicalDiagnosesMapResponse>(
    apiRoutes.getPhysiologicalDiagnosesMap('soybean', id),
    config,
  )

  return data
}
